import { render, staticRenderFns } from "./ActivityTab.vue?vue&type=template&id=4a3c71f3"
import script from "./ActivityTab.vue?vue&type=script&lang=js"
export * from "./ActivityTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports